import React from 'react';
import {
  ScaleFade,
  Fade,
  Stack,
  Box,
  Center,
  Text,
  Button,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { setShowInfoModal } from '../../store/redux/slices/productFactorySlice';
import { IconActionClose } from 'wg-fe-ui';
import { isSocialLoginUrl } from '../../../../app/src/features/authentication/constants/SocialAuth';

interface Props {
  message: string;
  onTryAgain: () => void;
  onReport: () => void;
  closeErrorModal?: () => void;
  isFetching?: boolean;
}

const OfferFailure: React.FC<React.PropsWithChildren<Props>> = ({
  message,
  onTryAgain,
  onReport,
  closeErrorModal,
  isFetching,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  return (
    <Center
      position="absolute"
      w="100%"
      h="100%"
      data-test-id="ADVISORY-CONVO_OFFERS_SIGNED-OFFERS_FAILURE-WRAPPER"
    >
      <Box w="95%" maxW="45rem">
        <ScaleFade in unmountOnExit>
          <Box
            bg="white"
            borderRadius="md"
            p="4"
            position="relative"
            zIndex="3"
          >
            {closeErrorModal && (
              <Box
                position="absolute"
                top="1"
                right="1"
                _hover={{ cursor: 'pointer', opacity: 0.7 }}
                transition="0.2s"
                onClick={closeErrorModal}
              >
                <IconActionClose />
              </Box>
            )}

            <Text textStyle="h5Headline" as="h1" mb="2">
              {t('Something went wrong')}
            </Text>
            <Text textStyle="largeBodyMedium" as="h2" mb="2">
              {message}
            </Text>
            {isSocialLoginUrl && (
              <Text textStyle="normalBody" color="text.gray">
                {t(
                  'Please feel free to contact your broker for more information if this problem persists',
                )}
              </Text>
            )}
            <Stack
              direction={{ base: 'column', laptop: 'row' }}
              mt="4"
              alignItems="center"
              spacing="2"
            >
              <Button
                onClick={onTryAgain}
                variant="dangerPrimary"
                isLoading={isFetching}
              >
                {t('Try again')}
              </Button>
              <Button
                onClick={() =>
                  isSocialLoginUrl
                    ? dispatch(setShowInfoModal(true))
                    : onReport()
                }
                variant="dangerSecondary"
              >
                {isSocialLoginUrl
                  ? t('Contact your broker')
                  : t('Report the problem')}
              </Button>
            </Stack>
          </Box>
        </ScaleFade>
      </Box>
      <Fade in unmountOnExit>
        <Box
          bg="rgba(34, 34, 34, 0.7)"
          backdropFilter="blur(10px)"
          w="100%"
          h="100%"
          position="absolute"
          left="0"
          top="0"
          zIndex="2"
        />
      </Fade>
    </Center>
  );
};

export default OfferFailure;
